// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ogpJ","footer":"ModalUpdate_footer__TBIo5"};